import { Modal } from "antd";
import { CSVDownload } from ".";

import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { useAllMovimentos } from "../../hooks/useMovimentos";
import moment from "moment";
import { formatMoney } from "../../../../infra/helpers";
import { formatNumber } from "../../../../infra/helpers/number";

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

interface CSVModalProps {
  onCancel: () => void;
  visible: boolean;
}

export function CSVModal({ onCancel, visible }: CSVModalProps) {
  const { data: dataAllMovimentos } = useAllMovimentos();

  const dataCSV = dataAllMovimentos?.map((movimentos: any) => ({
    'NotaFiscal': movimentos.NumeroNotaFiscal,
    'Data': moment(movimentos.DataMovimento).format('DD/MM/YYYY'),
    'Contato': movimentos.Nome + movimentos.Sobrenome,
    'Caneca': movimentos.Caneca,
    'Botijão': movimentos.Botijao,
    'ProdutoCodigoABS': movimentos.ProdutoCodigoABS,
    'ProdutoNome': movimentos.ProdutoNome,
    'ProdutoTouroRaca': movimentos.ProdutoTouroRaca,
    'ProdutoTouroRack': movimentos.ProdutoTouroRack,
    'ProdutoTouroSemenTipo': movimentos.ProdutoTouroSemenTipo,
    'Tipo': movimentos.Tipo,
    'Valor unitário': formatMoney(movimentos.ValorUnitarioReais),
    'Desconto': `${formatNumber(movimentos.DescontoPorcentagem)}%`,
    'Qtde': movimentos.Quantidade,
    'Retirante': movimentos.RetiranteContato,
  }));

  return (
    <Modal
      closable={false}
      open={visible}
      onCancel={onCancel}
      footer={false}
      className="h-[80vh] flex justify-center items-center"
    >
      <div className="w-[20rem] h-[5rem] flex item-center justify-center">
        {!dataCSV ?
          <div className="flex flex-col items-center justify-center">
            <Spin indicator={antIcon} className="mt-[1.5rem]" />
            Gerando arquivo...
          </div> :
          <div className="flex flex-col items-center justify-center">
            <CSVDownload dataSource={dataCSV} filename="movimentos" onCancel={onCancel} />
            Baixar arquivo
          </div>
        }
      </div>
    </Modal>
  );
}
